module.exports = __webpack_public_path__ + "img/'.85c6bcc9.svg";